// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: clip;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

#root,
.App {
  width: 100%;
  max-width: 100%;
  overflow-x: clip;
  position: relative;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


/* Variables y estilos de Bootstrap aislados exclusivamente para la Tienda y Páginas Web públicas */
.webstore-site-wrapper,
.ecom-modal,
.webstore-modal {
  --bs-primary: var(--ecom-primary, #0d6efd);
  --bs-primary-rgb: var(--ecom-primary-rgb, 13, 110, 253);
  --bs-link-color: var(--ecom-primary, #0d6efd);
  --bs-link-color-rgb: var(--ecom-primary-rgb, 13, 110, 253);
  --bs-link-hover-color: var(--ecom-primary-dark, #0a58ca);
  --bs-body-bg: var(--ecom-bg, #f8fafc);
  --bs-body-color: var(--ecom-text, #1e293b);
  --bs-border-color: var(--ecom-border, #e2e8f0);
}


/* Tarjeta interactiva de Artículos Relacionados */
.ecom-related-card {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out, border-color 0.18s ease-in-out !important;
}
.ecom-related-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08) !important;
  border-color: var(--ecom-primary, #0d6efd) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;;AAGA,mGAAmG;AACnG;;;EAGE,0CAA0C;EAC1C,uDAAuD;EACvD,6CAA6C;EAC7C,0DAA0D;EAC1D,wDAAwD;EACxD,qCAAqC;EACrC,0CAA0C;EAC1C,8CAA8C;AAChD;;;AAGA,kDAAkD;AAClD;EACE,gHAAgH;AAClH;AACA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,qDAAqD;AACvD","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: clip;\n  position: relative;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n}\n\n#root,\n.App {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: clip;\n  position: relative;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n/* Variables y estilos de Bootstrap aislados exclusivamente para la Tienda y Páginas Web públicas */\n.webstore-site-wrapper,\n.ecom-modal,\n.webstore-modal {\n  --bs-primary: var(--ecom-primary, #0d6efd);\n  --bs-primary-rgb: var(--ecom-primary-rgb, 13, 110, 253);\n  --bs-link-color: var(--ecom-primary, #0d6efd);\n  --bs-link-color-rgb: var(--ecom-primary-rgb, 13, 110, 253);\n  --bs-link-hover-color: var(--ecom-primary-dark, #0a58ca);\n  --bs-body-bg: var(--ecom-bg, #f8fafc);\n  --bs-body-color: var(--ecom-text, #1e293b);\n  --bs-border-color: var(--ecom-border, #e2e8f0);\n}\n\n\n/* Tarjeta interactiva de Artículos Relacionados */\n.ecom-related-card {\n  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out, border-color 0.18s ease-in-out !important;\n}\n.ecom-related-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08) !important;\n  border-color: var(--ecom-primary, #0d6efd) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
